module.exports = __webpack_public_path__ + "img/ic-qr.da003b95.svg";